;(function($, window, document){
    window.AddressForm = Me.view.extend({
        options: {
        },
        initialize: function() {
            _.bindAll(this, 'addEvents', 'addCodeToDOM', 'checkForSavedCodes', 'validatePromoCodes', 'toggleAddressShippingForm', 'toggleAccountCreationForm', 'toggleNewsletterCheckbox');
            this.addEvents();
            this.toggleAddressShippingForm();
            this.toggleAccountCreationForm();

            //fetch code in sessions, then reapply them
            this.checkForSavedCodes();

            if (this.$('input[type="tel"]').length !== 0) {
                // @NOTE: Validate Me added to only display phone mask. No validation is performed on frontend side
                this.validation = new Me.validate(this.$el, {});
                var scope = this;
                this.$('input[type="tel"]').each(function(index, element) {
                    scope.validation.addField({ name: $(element).attr('name'), type: 'phone' });
                });
            }
        },
        addEvents: function(e){
            this.$('input[type=radio][name=useSameAddress]').on('change', this.toggleAddressShippingForm);
            this.$('input[type=checkbox][name=createAccount]').on('change', this.toggleAccountCreationForm);
            this.$('input[type=checkbox][name=subscribeNewsletter]').on('change', this.toggleNewsletterCheckbox);
            this.$('.validate-promocodes').on('click', this.validatePromoCodes)
        },
        addCodeToDOM: function(code, value){
            var codeTemplate = $(this.$('#applied-code-template').html()).clone();

            codeTemplate.find('.code').html(code);
            codeTemplate.find('input').val(code);
            codeTemplate.find('.value').html('-' + value);
            this.$('#applied-codes').append(codeTemplate);

            this.$('#applied-codes .applied-code .close-button').on('click', this.removeCode);
        },
        ajaxSuccess: function(message){
            this.$('[name="promoCodeValidation"]').val('');

            this.addCodeToDOM(message.code, message.value);

            this.$('#applied-codes .error').addClass('hide');
        },
        ajaxError: function(error){
            this.$('#applied-codes .error').html(JSON.parse(error.responseText).message).removeClass('hide');
        },
        checkForSavedCodes: function(){
            if(this.$('#applied-codes').attr('data-session-codes')){
                var codesArray = JSON.parse(this.$('#applied-codes').attr('data-session-codes'));

                for(var i = 0; i < codesArray.length; i++){
                    this.addCodeToDOM(codesArray[i].code, codesArray[i].value);
                }
            }
        },
        validatePromoCodes: function(e){
            e.preventDefault();

            var view = this;

            var formData = new FormData();

            var promoCodesValues = view.$("#applied-codes input.promocode-inputs").map(function(index,value){
                return $(value).val();
            }).get().join(",");

            if(this.$('[name="promoCodeValidation"]').val() == ''){
                return;
            }

            formData.append('promoCodeValidation', view.$('[name="promoCodeValidation"]').val());
            formData.append('promoCode', promoCodesValues);
            formData.append('token', view.$('[name="_token"]').val());

            $.ajax({
                cache: false,
                contentType: false,
                processData: false,
                method: 'POST',
                url: $(e.currentTarget).attr('data-service'),
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: formData,
                dataType: 'json',
                success: $.proxy(view.ajaxSuccess, view),
                error: $.proxy(view.ajaxError, view)
            });
        },
        removeCode: function(e){
            e.preventDefault();

            $(e.currentTarget).off('click', this.removeCode);
            $(e.currentTarget).parents('.applied-code').remove();
        },
        toggleAddressShippingForm: function(e){
            if(this.$('#newAddress').is(':checked')){
                this.$('.shipping-address-form').removeClass('hide');
            }else{
                this.$('.shipping-address-form').addClass('hide');
            }
        },
        toggleAccountCreationForm: function(e){
            if(this.$('input[type=checkbox][name=createAccount]').is(':checked')){
                gtag('event', 'set_checkout_option', {
                    "checkout_step": 1,
                    "checkout_option": "create account",
                    "value": "true"
                });
                if (window.fbq) {
                    fbq('trackCustom', 'CheckoutOption', {
                        create_account: 'true'
                    });
                }
                this.$('.account-creation-form').removeClass('hide');
            }else{
                gtag('event', 'set_checkout_option', {
                    "checkout_step": 1,
                    "checkout_option": "create account",
                    "value": "false"
                });
                if (window.fbq) {
                    fbq('trackCustom', 'CheckoutOption', {
                        create_account: 'false'
                    });
                }
                this.$('.account-creation-form').addClass('hide');
            }
        },
        toggleNewsletterCheckbox: function(){
            if(this.$('input[type=checkbox][name=subscribeNewsletter]').is(':checked')){
                gtag('event', 'set_checkout_option', {
                    "checkout_step": 1,
                    "checkout_option": "newsletter",
                    "value": "true"
                });
                if (window.fbq) {
                    fbq('trackCustom', 'CheckoutOption', {
                        newsletter_subscription: 'true'
                    });
                }
            }else{
                gtag('event', 'set_checkout_option', {
                    "checkout_step": 1,
                    "checkout_option": "newsletter",
                    "value": "false"
                });
                if (window.fbq) {
                    fbq('trackCustom', 'CheckoutOption', {
                        newsletter_subscription: 'false'
                    });
                }
            }
        }
    });
}(jQuery, window, document));
